import { forwardRef } from 'react';
import type { InputHTMLAttributes } from 'react';

interface TextFieldProps extends InputHTMLAttributes<HTMLInputElement> {
  label: string;
  error?: string;
}

// forwardRef so react-hook-form's register() can attach its ref.
export const TextField = forwardRef<HTMLInputElement, TextFieldProps>(
  ({ label, error, id, className, ...rest }, ref) => {
    const inputId = id ?? rest.name ?? label;
    return (
      <div className="mb-3">
        <label htmlFor={inputId} className="form-label">
          {label}
        </label>
        <input
          id={inputId}
          ref={ref}
          className={`form-control${error ? ' is-invalid' : ''}${className ? ` ${className}` : ''}`}
          {...rest}
        />
        {error && <div className="invalid-feedback">{error}</div>}
      </div>
    );
  },
);
TextField.displayName = 'TextField';
